module.exports = __webpack_public_path__ + "static/media/Street_cleaner.5750abd3.mp3";